var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "topmenu", class: _vm.setClass }, [
    _c(
      "div",
      { staticClass: "logo" },
      [
        _vm.showAnonymousMenu
          ? [
              _c("img", {
                attrs: { src: "/images/logo.svg", alt: "Simply Logo" },
              }),
            ]
          : [
              _c("router-link", { attrs: { to: _vm.setLogoLink } }, [
                _c("img", {
                  attrs: { src: "/images/logo.svg", alt: "Simply Logo" },
                }),
              ]),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _vm.showMainMenu
      ? _c(
          "menu",
          [
            _c("router-link", { attrs: { to: "/projects/active" } }, [
              _vm._v("Overview"),
            ]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/account" } }, [
              _vm._v("Account"),
            ]),
            _vm._v(" "),
            _vm.showAdminMemberMenu
              ? _c(
                  "span",
                  [
                    _c("router-link", { attrs: { to: "/member/list" } }, [
                      _vm._v("Users"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSuperAdmin
              ? _c(
                  "span",
                  [
                    _c("router-link", { attrs: { to: "/settings/list" } }, [
                      _vm._v("Settings"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("a", { attrs: { href: "/api/member/logout" } }, [
              _vm._v("Sign out"),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showDataViewMenu
      ? _c("div", { staticClass: "breadcrump" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$store.state.dataView.forecast.projectTitle)
          ),
          _c(
            "span",
            { staticStyle: { "padding-left": "5px", "padding-right": "5px" } },
            [_vm._v(">")]
          ),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$store.state.dataView.forecast.programTitle)
          ),
          _c(
            "span",
            { staticStyle: { "padding-left": "5px", "padding-right": "5px" } },
            [_vm._v(">")]
          ),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$store.state.dataView.forecast.title) +
              "\n    "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showDataViewMenu
      ? _c(
          "menu",
          [
            _vm.$store.state.dataView.forecast.viewUrl
              ? _c(
                  "router-link",
                  { attrs: { to: _vm.$store.state.dataView.forecast.viewUrl } },
                  [_vm._v("Simulation")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.dataView.forecast.dataUrl
              ? _c(
                  "router-link",
                  { attrs: { to: _vm.$store.state.dataView.forecast.dataUrl } },
                  [_vm._v("Data")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAnonymousMenu
              ? _c("a", { attrs: { href: "/api/member/logout" } }, [
                  _vm._v("Sign out"),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }